<mat-form-field class="dict-hiperio-config">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="filterControl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono umowy">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let item of items"
                [value]="item.id" multiLineOption>
      {{ item.insuranceCompany.name }} ({{item.integrationName}})
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
